import React, { useState , useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { Box } from '@mui/material';
import { treeDeparts } from '../../modules/deptModule/departs';
import HeadquartersYearGoalTable from '../../components/salesgoalmng/HeadquartersYearGoalTable'
import HeadquartersYearGoalChart from '../../components/salesgoalmng/HeadquartersYearGoalChart';


function createDataByYear(id, dptNm, goal, result, achieveRate) {
    return { id, dptNm, goal, result, achieveRate };
}
  
const HeadquartersYearGoalContainer = () => {
    const dispatch = useDispatch();
  
    const [rows, setRows] = useState([]);
  
    const { departs, error, loading } = useSelector(
      ({ departModule, loading }) => ({
        departs: departModule.departs.departs,
        error: departModule.departs.error,
        loading: loading['depart/TREE_DEPART'],
      }),
    );
  
    useEffect(() => {
      if (!departs) {
        dispatch(treeDeparts());
      }
  
    }, [departs, dispatch]);
  
    useEffect(() => {
      if (departs?.children) {
        const filteredDeaprt = _.filter(departs?.children, (depart) => depart.Level === "1");
        
        let data = []
        _.forEach(filteredDeaprt,(dept)=>{
          let goal = Math.floor(Math.random() * 1000);
          let result = Math.floor(Math.random() * 1000);
          let rate = (result/goal)*100;
          data.push(createDataByYear(dept.id,dept.name,goal,result,rate.toFixed(2)))
        });
        setRows(data);
      }
  
    }, [departs])


  return (
      <Box>
          <HeadquartersYearGoalTable rows={rows}/>
          <HeadquartersYearGoalChart data={rows}/>
      </Box>
  )
}

export default HeadquartersYearGoalContainer